import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  ExpandMore,
  MenuRounded,
  CloseRounded,
  DashboardOutlined,
  GroupRounded,
  PersonAddAltRounded,
  SecurityRounded,
  VerifiedUserRounded,
  CreateNewFolderRounded,
  HourglassTopRounded,
  TimelineRounded,
  ListAltRounded,
  TaskAltRounded,
  CategoryRounded,
  ReceiptLongRounded,
  NoteAddRounded,
  LibraryBooksRounded,
  PostAddRounded,
  WorkHistoryRounded,
  AddBusinessRounded,
  BusinessRounded,
  MenuBookRounded,
  DynamicFormRounded,
  TextSnippetRounded,
  HelpCenterRounded,
  SlideshowRounded,
  ViewCarouselRounded,
  PhotoLibraryRounded,
  TrendingUpRounded,
  InsertChartRounded,
  PlayCircleRounded,
  ManageAccountsOutlined,
  PublicOffOutlined,
} from "@mui/icons-material";
import HistoryIcon from "@mui/icons-material/History";

// ── Shared CSS injected once ──────────────────────────────────────────────────
let _cssInjected = false;
const injectSidebarCSS = () => {
  if (typeof document === "undefined" || _cssInjected) return;
  _cssInjected = true;
  const s = document.createElement("style");
  s.id = "app-sidebar-styles";
  s.textContent = `
    .app-sidebar-toggle {
      position: fixed; top: 16px; left: 16px; z-index: 1300;
      width: 42px; height: 42px; border-radius: 10px; border: 1px solid #e5e7eb;
      background: #fff; color: #111827; display: flex; align-items: center; justify-content: center;
      cursor: pointer; box-shadow: 0 2px 8px rgba(0,0,0,0.08); transition: background .15s;
    }
    .app-sidebar-toggle:hover { background: #f3f4f6; }

    .app-sidebar-overlay {
      position: fixed; inset: 0; background: rgba(15,23,42,0.5);
      z-index: 1190; backdrop-filter: blur(2px);
    }

    .app-sidebar {
      position: fixed; top: 0; left: 0; height: 100vh; width: 272px;
      background: #111827; color: #cbd5e1; display: flex; flex-direction: column;
      transform: translateX(-100%); transition: transform .25s ease;
      z-index: 1200; flex-shrink: 0;
    }
    .app-sidebar.open { transform: translateX(0); }

    .app-sidebar-brand {
      padding: 22px 20px 18px; border-bottom: 1px solid rgba(255,255,255,0.06);
      display: flex; align-items: center; gap: 10px; flex-shrink: 0;
    }
    .app-sidebar-brand-mark {
      width: 34px; height: 34px; border-radius: 9px; background: #2563eb;
      display: flex; align-items: center; justify-content: center;
      font-weight: 800; font-size: 15px; color: #fff; flex-shrink: 0;
    }
    .app-sidebar-brand-text { font-size: 15px; font-weight: 700; color: #fff; line-height: 1.2; }
    .app-sidebar-brand-sub { font-size: 11px; color: #94a3b8; margin-top: 1px; }

    .app-sidebar-close {
      margin-left: auto; background: none; border: none; color: #94a3b8;
      cursor: pointer; display: none; padding: 4px; border-radius: 6px;
    }
    .app-sidebar-close:hover { background: rgba(255,255,255,0.08); color: #fff; }

    .app-sidebar-user {
      padding: 14px 20px; border-bottom: 1px solid rgba(255,255,255,0.06);
      display: flex; align-items: center; gap: 10px; flex-shrink: 0;
    }
    .app-sidebar-user-avatar {
      width: 32px; height: 32px; border-radius: 50%; background: rgba(37,99,235,0.18);
      color: #93c5fd; display: flex; align-items: center; justify-content: center;
      font-weight: 700; font-size: 13px; flex-shrink: 0; text-transform: uppercase;
    }
    .app-sidebar-user-info { overflow: hidden; }
    .app-sidebar-user-email {
      font-size: 12.5px; font-weight: 600; color: #f1f5f9;
      white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    }
    .app-sidebar-user-role {
      font-size: 11px; color: #94a3b8; text-transform: capitalize; margin-top: 1px;
    }

    .app-sidebar-nav { flex: 1; overflow-y: auto; padding: 10px 0 20px; }
    .app-sidebar-nav::-webkit-scrollbar { width: 5px; }
    .app-sidebar-nav::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.12); border-radius: 10px; }

    .app-nav-item {
      display: flex; align-items: center; gap: 11px;
      padding: 9px 16px; margin: 1px 10px; border-radius: 8px;
      color: #cbd5e1; font-size: 13.5px; font-weight: 500;
      text-decoration: none; transition: background .15s, color .15s;
      white-space: nowrap; overflow: hidden;
    }
    .app-nav-item svg { font-size: 19px; flex-shrink: 0; opacity: .85; }
    .app-nav-item:hover { background: rgba(255,255,255,0.06); color: #fff; }
    .app-nav-item.active { background: #2563eb; color: #fff; font-weight: 600; }
    .app-nav-item.active svg { opacity: 1; }
    .app-nav-item.nested { padding-left: 46px; font-size: 13px; }

    .app-nav-section-btn {
      display: flex; align-items: center; gap: 11px; width: calc(100% - 20px);
      margin: 6px 10px 1px; padding: 9px 16px; background: none; border: none;
      color: #94a3b8; font-size: 11.5px; font-weight: 700; text-transform: uppercase;
      letter-spacing: .6px; cursor: pointer; border-radius: 8px; transition: background .15s, color .15s;
    }
    .app-nav-section-btn:hover { background: rgba(255,255,255,0.05); color: #e2e8f0; }
    .app-nav-section-btn svg:first-of-type { font-size: 19px; flex-shrink: 0; opacity: .85; }
    .app-nav-section-chevron {
      margin-left: auto; font-size: 18px !important; transition: transform .2s ease; opacity: .7;
    }
    .app-nav-section-chevron.open { transform: rotate(180deg); }

    .app-nav-section-items {
      display: grid; overflow: hidden; transition: grid-template-rows .22s ease;
      grid-template-rows: 0fr;
    }
    .app-nav-section-items.open { grid-template-rows: 1fr; }
    .app-nav-section-items > div { overflow: hidden; }

    @media (min-width: 1024px) {
      .app-sidebar { position: sticky; top: 0; transform: none; }
      .app-sidebar-overlay { display: none; }
      .app-sidebar-toggle { display: none; }
      .app-sidebar-close { display: none; }
    }
  `;
  document.head.appendChild(s);
};

// ── Sidebar navigation configuration ──────────────────────────────────────────
const sidebarNavItems = {
  userManagement: [
    { title: "View Admin Users", path: "/admin/users", icon: <GroupRounded /> },
    { title: "View Donor Users", path: "/admin/donor/users", icon: <GroupRounded /> },
    { title: "Create User", path: "/admin/create/user", icon: <PersonAddAltRounded /> },
    { title: "Roles", path: "/admin/all/roles", icon: <SecurityRounded /> },
    { title: "Add Role", path: "/admin/add/role", icon: <VerifiedUserRounded /> },
     { title: "Manage Emails", path: "/admin/update/email", icon: <VerifiedUserRounded /> },
  ],
  campaigns: [
    { title: "Create Campaigns", path: "/admin/create/type", icon: <CreateNewFolderRounded /> },
    { title: "Pending Campaigns (WF)", path: "/admin/history/donate", icon: <HourglassTopRounded /> },
    { title: "Workflow", path: "/admin/all/wfuser", icon: <TimelineRounded /> },
    { title: "All Campaigns", path: "/admin/all/donate/types/all", icon: <ListAltRounded /> },
    { title: "Active Campaigns", path: "/admin/all/donate/types/active", icon: <TaskAltRounded /> },
    { title: "Categories", path: "/admin/create/category", icon: <CategoryRounded /> },
  ],
  countries: [
    { title: "Manage Countries", path: "/admin/add/countrires", icon: <HourglassTopRounded /> },
    { title: "Manage States", path: "/admin/add/states", icon: <HourglassTopRounded /> },
    { title: "Manage Cities", path: "/admin/add/cities", icon: <HourglassTopRounded /> },
  ],
  banks: [
    { title: "Create Bank", path: "/create/bank", icon: <HourglassTopRounded /> },
    { title: "All Banks", path: "/all/banks", icon: <HourglassTopRounded /> },
  ],
  donations: [
    { title: "Pending Payments (WF)", path: "/admin/history/payments", icon: <HourglassTopRounded /> },
    { title: "Manage Exchange Rates", path: "/admin/update/exchange/rates", icon: <HourglassTopRounded /> },
    { title: "All Transactions", path: "/admin/payments/combine/all", icon: <ReceiptLongRounded /> },
    { title: "Verified Transactions", path: "/admin/payments/combine/success", icon: <ReceiptLongRounded /> },
    { title: "Pending Transactions", path: "/admin/payments/combine/inprocess", icon: <ReceiptLongRounded /> },
    { title: "Rejected Transactions", path: "/admin/payments/combine/rejected", icon: <ReceiptLongRounded /> },
    { title: "Qurbani Transactions", path: "/admin/payments/combine/qurbani", icon: <ReceiptLongRounded /> },
  ],
  cheque: [
    { title: "Verified Cheque Transactions", path: "/admin/payments/cheque/success", icon: <ReceiptLongRounded /> },
    { title: "Pending Cheque Transactions", path: "/admin/payments/cheque/inprocess", icon: <ReceiptLongRounded /> },
    { title: "Rejected Cheque Transactions", path: "/admin/payments/cheque/rejected", icon: <ReceiptLongRounded /> },
    { title: "Qurbani Cheque Transactions", path: "/admin/payments/cheque/qurbani", icon: <ReceiptLongRounded /> },
  ],
  manageBlogs: [
    { title: "Create Blog", path: "/createBlog", icon: <NoteAddRounded /> },
    { title: "View Blogs", path: "/admin/blogs", icon: <LibraryBooksRounded /> },
    { title: "Create Job", path: "/add/job", icon: <PostAddRounded /> },
    { title: "Jobs", path: "/admin/jobs", icon: <WorkHistoryRounded /> },
  ],
  manageBranches: [
    { title: "Create Branch", path: "/admin/add/branch", icon: <AddBusinessRounded /> },
    { title: "All Branches", path: "/admin/all/branches", icon: <BusinessRounded /> },
  ],
  managePages: [
    { title: "Create Page", path: "/admin/add/page", icon: <NoteAddRounded /> },
    { title: "All Pages", path: "/admin/all/pages", icon: <MenuBookRounded /> },
  ],
  manageMenus: [
    { title: "Create Header Menu", path: "/admin/header/menu", icon: <MenuRounded /> },
  ],
  manageContents: [
    { title: "Manage Sections", path: "/admin/update/section/status", icon: <DynamicFormRounded /> },
    { title: "All Text Content", path: "/admin/all/text/content", icon: <TextSnippetRounded /> },
    { title: "All Faq Content", path: "/admin/all/faq/content", icon: <HelpCenterRounded /> },
    { title: "Logo Slider Content", path: "/admin/all/logo/content", icon: <SlideshowRounded /> },
    { title: "Card Slider Content", path: "/admin/all/card/content", icon: <ViewCarouselRounded /> },
    { title: "All Media Content", path: "/admin/all/media/content", icon: <PhotoLibraryRounded /> },
    { title: "Newsletter Management", path: "/admin/footer", icon: <PhotoLibraryRounded /> },
    { title: "SEO", path: "/seo/content", icon: <TrendingUpRounded /> },
    { title: "Media/Reports", path: "/content/videos", icon: <InsertChartRounded /> },
    { title: "View Videos/Publications", path: "/admin/all/media", icon: <PlayCircleRounded /> },
  ],
};

const formatSectionTitle = (key) =>
  key.replace(/([A-Z])/g, " $1").replace(/^./, (c) => c.toUpperCase());

export function Sidebar() {
  injectSidebarCSS();

  const { isAuthenticated, user } = useSelector((state) => state.user);
  const { permissions } = useSelector((state) => state.permissions);
  const location = useLocation();

  const [open, setOpen] = useState({});
  const [mobileOpen, setMobileOpen] = useState(false);
  const initializedRef = useRef(false);

  const isActive = (path) => location.pathname === path;
  const handleToggle = (menu) => setOpen((prev) => ({ ...prev, [menu]: !prev[menu] }));
  const hasRole = (role) => user?.role_name === role;
  const closeMobile = () => setMobileOpen(false);

  const hasAccess = (path) => {
    if (!permissions || permissions.length === 0 || !user?.roleid) return false;
    return permissions.some(
      (p) => p.page_url === path && p.active === 1 && p.roleid === user.roleid
    );
  };

  const filterMenu = (section) =>
    sidebarNavItems[section]?.filter((item) => hasAccess(item.path)) || [];

  const dashboardPath = hasAccess("/dashboard") ? "/dashboard" : "/admin/dashboard";

  // Auto-expand the section containing the currently active route (once)
  useEffect(() => {
    if (initializedRef.current) return;
    initializedRef.current = true;
    const next = {};
    if (hasRole("admin")) {
      if (sidebarNavItems.userManagement.some((i) => i.path === location.pathname)) {
        next.userManagement = true;
      }
    }
    Object.keys(sidebarNavItems).forEach((key) => {
      if (key === "userManagement") return;
      if (sidebarNavItems[key].some((i) => i.path === location.pathname)) next[key] = true;
    });
    if (Object.keys(next).length) setOpen((prev) => ({ ...prev, ...next }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const userInitial = (user?.email || "?").charAt(0);
  const roleLabel = (user?.role_name || "").replace(/_/g, " ");

  return (
    <>
      {/* Mobile toggle button */}
      <button className="app-sidebar-toggle" onClick={() => setMobileOpen(true)} aria-label="Open menu">
        <MenuRounded />
      </button>

      {/* Mobile backdrop */}
      {mobileOpen && <div className="app-sidebar-overlay" onClick={closeMobile} />}

      <aside className={`app-sidebar${mobileOpen ? " open" : ""}`}>
        {/* Brand */}
        <div className="app-sidebar-brand">
          <div className="app-sidebar-brand-mark">A</div>
          <div>
            <div className="app-sidebar-brand-text">Akhuwat Admin</div>
            <div className="app-sidebar-brand-sub">Control Panel</div>
          </div>
          <button className="app-sidebar-close" onClick={closeMobile} aria-label="Close menu">
            <CloseRounded />
          </button>
        </div>

        {/* User */}
        {isAuthenticated && user && (
          <div className="app-sidebar-user">
            <div className="app-sidebar-user-avatar">{userInitial}</div>
            <div className="app-sidebar-user-info">
              <div className="app-sidebar-user-email">{user.email}</div>
              {roleLabel && <div className="app-sidebar-user-role">{roleLabel}</div>}
            </div>
          </div>
        )}

        {/* Navigation */}
        <nav className="app-sidebar-nav">
          <SidebarItem
            title="Dashboard"
            icon={<DashboardOutlined />}
            path={dashboardPath}
            isActive={isActive(dashboardPath)}
            onClick={closeMobile}
          />


                    <SidebarItem
            title="Public Pages"
            icon={<PublicOffOutlined />}
            path={'/'}
            isActive={isActive('/')}
            onClick={closeMobile}
          />

          {isAuthenticated && user?.role_name === "user" && (
            <>
              <SidebarItem
                title="Donate Now"
                icon={<ReceiptLongRounded />}
                path="/donate/detail"
                isActive={isActive("/donate/detail")}
                onClick={closeMobile}
              />
              <SidebarItem
                title="Donation History"
                icon={<HistoryIcon />}
                path="/admin/payments/combine/all"
                isActive={isActive("/admin/payments/combine/all")}
                onClick={closeMobile}
              />
            </>
          )}

          {hasRole("admin") && (
            <SidebarMenu
              title="User Management"
              icon={<ManageAccountsOutlined />}
              open={!!open.userManagement}
              onToggle={() => handleToggle("userManagement")}
              items={sidebarNavItems.userManagement}
              isActive={isActive}
              onLinkClick={closeMobile}
            />
          )}

          {Object.keys(sidebarNavItems).map((sectionKey) => {
            if (sectionKey === "userManagement") return null;
            const filteredItems = filterMenu(sectionKey);
            if (filteredItems.length === 0) return null;
            const firstItem = sidebarNavItems[sectionKey][0];
            return (
              <SidebarMenu
                key={sectionKey}
                title={formatSectionTitle(sectionKey)}
                icon={firstItem.icon || <ListAltRounded />}
                open={!!open[sectionKey]}
                onToggle={() => handleToggle(sectionKey)}
                items={filteredItems}
                isActive={isActive}
                onLinkClick={closeMobile}
              />
            );
          })}
        </nav>
      </aside>
    </>
  );
}

function SidebarItem({ title, icon, path, isActive, onClick }) {
  return (
    <Link to={path} className={`app-nav-item${isActive ? " active" : ""}`} onClick={onClick}>
      {icon}
      <span>{title}</span>
    </Link>
  );
}

function SidebarMenu({ title, icon, open, onToggle, items, isActive, onLinkClick }) {
  return (
    <div>
      <button className="app-nav-section-btn" onClick={onToggle}>
        {icon}
        <span>{title}</span>
        <ExpandMore className={`app-nav-section-chevron${open ? " open" : ""}`} />
      </button>
      <div className={`app-nav-section-items${open ? " open" : ""}`}>
        <div>
          {items.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`app-nav-item nested${isActive(item.path) ? " active" : ""}`}
              onClick={onLinkClick}
            >
              {item.icon}
              <span>{item.title}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}